<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2GEpLH/tc-custom/9781524862473.jpg?1729082495323" alt="This image is the cover for the book 55 Slightly Sinister Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">55 Slightly Sinister Stories
      </h1>
      <p class="bookDescription body article font2">
        <p>Size does matter in these delightfully tiny tales populated with narcoleptic drivers, bickering backers, suspicious spouses, and other memorable characters. Full of dark humor, intrigue, and absurdity, this collection of slightly sinister (and occasionally sweet) stories delivers a bite-size reading experience to satisfy any literary craving.<br/> </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Racha Mourtada
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58c9db76